import React, { useEffect, useState } from 'react';
import { Menu } from 'lucide-react';
import NotificationPopup from '../atomic_components/notificationpopup';
import { Link, useNavigate } from 'react-router-dom';
import useAuthStore from '../store';
import { jwtDecode } from 'jwt-decode';
// import { useTheme } from '../ui/Theme-context';

const Header = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {

  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const [user, setUser] = useState(null);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  const toggleNotification = () => {
    setIsNotificationOpen(!isNotificationOpen);
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  

useEffect(() => {
  const token = localStorage.getItem("userInfo");
  console.log("Token from localStorage:", token);
if (token) {
    const storedUser = JSON.parse(token); 
    setUser(storedUser); 
  }
}, []);

  return (
    <header className="bg-[#134A9F] border-b border-gray-200 h-16 flex items-center justify-between px-4 fixed top-0 right-0 left-0 z-10">
      <div className="flex items-center gap-4">
        <button onClick={toggleMobileMenu} aria-label="Toggle sidebar">
          <Menu className="text-[#ffff] pointer" />
        </button>
        <h1 className="text-[#ffff] text-[20px] font-semibold">
          Correspondence
        </h1>
      </div>

      <div className="flex items-center gap-4 text-[#fff]">
        <div className="flex items-center">

          <button className='hidden md:block' onClick={toggleNotification}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-bell-icon lucide-bell"><path d="M10.268 21a2 2 0 0 0 3.464 0" /><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" /></svg>
          </button>

          <Link>
          <button className='md:hidden block'>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-bell-icon lucide-bell"><path d="M10.268 21a2 2 0 0 0 3.464 0" /><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" /></svg>
          </button>
          </Link>
            <div className='flex gap-2 items-center' onClick={toggleDropdown}>        
              <img
                src="/assets/avatar01.png"
                alt="Profile"
                className="h-8 w-8 rounded-full ml-2 md:ml-5 cursor-pointer"
              />
          <div className="relative inline-block text-left ">
            <div  className="cursor-pointer">
            <div className="flex items-center gap-1 text-sm font-medium">
              {user?.Name?.split(/\\+/).pop()}
              {dropdownOpen ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M5 15l7-7 7 7" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M19 9l-7 7-7-7" />
                </svg>
              )}
            </div>
          </div>

            {/* ...............Dropdown Menu............... */}

            {dropdownOpen && (
              <div className="absolute right-0 w-[200px] bg-white border border-gray-200 rounded-md shadow-lg z-10 mt-[22px] px-2 py-2">
              <div className='flex gap-2 items-center'>
                <img
                  src="/assets/avatar01.png"
                  alt="Profile"
                  className="rounded-full h-10 w-10 ml-2 cursor-pointer mt-2"
                  />
                  <div className='mt-1'>
                    <p className="text-sm font-medium text-[#222222]">{user?.Name?.split(/\\+/).pop()}</p>
                    {/* <p className="text-sm font-medium text-[#222222]">guestmail.com</p> */}
                  </div>          
               </div>
              <div className='flex items-center gap-1 hover:bg-gray-100 rounded-md mt-2'>         
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="#222222" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-settings-icon lucide-settings"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/></svg>
                <button
                  onClick={() => {
                    navigate("/settings");
                    setDropdownOpen(false);
                  }}
                  className="block w-full text-left py-2 text-[14px] text-gray-700 "
                >
                  Account Settings
                </button>
                </div>
                <div className='flex items-center gap-1 hover:bg-gray-100 rounded-md'>         
                <svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-help-icon lucide-circle-help"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>              
                  <button
                  onClick={() => {
                    navigate("/help");
                    setDropdownOpen(false);
                  }}
                  className="block w-full text-left px-1 py-2 text-[14px] text-gray-700 "
                >
                  Help Center
                </button>
                </div>
                <div className='flex items-center hover:bg-red-100 border-t'>         
                <svg  xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="#FF0000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-power-icon lucide-power"><path d="M12 2v10"/><path d="M18.4 6.6a9 9 0 1 1-12.77.04"/></svg>
                <button
                  onClick={ handleLogout }
                  className="block w-full text-left px-2 py-2 text-[14px] text-red-600 "
                >
                  Logout
                </button>
                </div>
              </div>
            )}
          </div>
          </div>
        </div>
      </div>

      <NotificationPopup 
      isOpen={isNotificationOpen}
        onClose={() => setIsNotificationOpen(false)}
        onApply={() => { }}
        onClear={() => { }}
         />
    </header>
  );
};

export default Header;

//  {user && (
//   <div className="text-left">
//     <div className="text-sm font-medium">DevTest</div>
//     <div className="text-xs text-gray-500">{user.email}</div>
//   </div>
//   )}
